import { createAction } from '@reduxjs/toolkit';
const SET_IS_LOADING = 'SET_IS_LOADING';
const SET_IS_ERROR = 'SET_IS_ERROR';
export const SET_IS_AUTHORIZED = 'SET_IS_AUTHORIZED';
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
const SET_PROFILE_MENU_DATA = 'SET_PROFILE_MENU_DATA';
const SET_PROFILE_DEALER_INFO = 'SET_PROFILE_DEALER_INFO';
const SET_IS_LOADED_LOGOUT_IFRAME = 'SET_IS_LOADED_LOGOUT_IFRAME';
export const setIsLoadingAction = createAction(SET_IS_LOADING);
export const setIsErrorAction = createAction(SET_IS_ERROR);
export const setAuthorizedStatusAction = createAction(SET_IS_AUTHORIZED);
export const setProfileDataAction = createAction(SET_PROFILE_DATA);
export const setProfileMenuDataAction = createAction(SET_PROFILE_MENU_DATA);
export const setProfileDealerInfo = createAction(SET_PROFILE_DEALER_INFO);
export const setIsLoadedLogoutIframe = createAction(SET_IS_LOADED_LOGOUT_IFRAME);
